// Contact box toggle
function contactBox() {
    $(".contact-box button").click(function () {
        $(".contact-box .panel").toggle();
    });

    $(".contact-box .svg-icon").click(function () {
        $(".contact-box .panel").toggle();
    });
}
